import Alert from '~/common/components/Alerts/Alert';
import Stack from '~/common/components/Stacks/Stack';
import { ALERT_SEVERITY } from '~/common/constants';

type AlertsProps = {
  alerts?: Array<{
    title?: string;
    severity?: number;
    description?: string | React.ReactNode;
  }>;
} & React.ComponentProps<typeof Stack>;

function getStatus(severity: number) {
  switch (severity) {
    case ALERT_SEVERITY.HINT:
      return 'info';
    case ALERT_SEVERITY.WARNING:
      return 'warning';
    case ALERT_SEVERITY.ALERT:
      return 'error';
    case ALERT_SEVERITY.SUCCESS:
      return 'success';
    case ALERT_SEVERITY.ATTENTION:
      return 'extractionFailed';
    default:
      return null;
  }
}

const Alerts = ({ alerts, ...rest }: Readonly<AlertsProps>) => {
  if (!alerts.length) {
    return null;
  }

  return (
    <Stack spacing={4} {...rest}>
      {alerts.map((alert, i) => (
        <Alert
          title={alert.title}
          status={getStatus(alert.severity)}
          key={`${typeof alert.description === 'string' ? alert.description : i}-${alert.severity}`}
        >
          {alert.description}
        </Alert>
      ))}
    </Stack>
  );
};

Alerts.defaultProps = {
  alerts: [],
};

export default Alerts;
